var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-container"},[_c('div',{class:("word " + _vm.color)},[_vm._v(_vm._s(_vm.text))]),(_vm.showCount)?_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }